import { Injectable } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { ResponseApi } from '../../../../dtos/response-api';
import { Observable } from 'rxjs';
import { Municipio } from '../../../../dtos/sai/core/municipio';

@Injectable({
  providedIn: 'root'
})
export class MunicipioService {

  private baseUrl = `${environment.apiUrl}/sai/core/municipio`;

  constructor(private http: HttpClient) { }

  getAll(): Observable<ResponseApi<Municipio[]>> {
    return this.http.get<ResponseApi<Municipio[]>>(this.baseUrl);
  }


  getMunicipioByEstado(codEstadoEst: Number): Observable<ResponseApi<Municipio[]>> {
    return this.http.get<ResponseApi<Municipio[]>>(`${this.baseUrl}/${codEstadoEst}`);
  }
}

